import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { publishWebpage } from 'action/webpage'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, publishText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${publishText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${publishText}ed`
    },
    title: {
      error: `There has been an issue ${publishText}ing ${title}`,
      success: `Webpage ${publishText}ed`
    }
  }
})

const PublishWebpage = ({ publishWebpage, webpage: { uuid, title, published: isPublished, is_draft: isDraft }, pagination }) => {
  const publishText = isPublished ? 'unpublish' : 'publish'

  const handleSubmit = () => publishWebpage(uuid)

  const { decide, outcome } = generateModalText(title, publishText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(publishText)} Webpage`}</Button>
  )
}

PublishWebpage.propTypes = {
  pagination: PropTypes.object,
  publishWebpage: PropTypes.func,
  webpage: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  publishWebpage: bindActionCreators(publishWebpage, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.webpage.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishWebpage)
